<template>
  <div>
    <div v-if="!affichageRoueCheckboxs">
      <div class="columns is-desktop">
        <AdminEnAttenteTermine
          class="column is-offset-one-quarter is-half"
          align="center"
        />
      </div>
      <div id="switchDots" class="is-success check">
        <b-switch
          :value="true"
          type="is-success"
          class="mt-1 mb-1"
          v-model="affichageIds"
          >{{ $t("admin.dots") }}</b-switch
        >
      </div>
    </div>
    <AdminRoueCheckboxs v-if="affichageRoueCheckboxs" />
  </div>
</template>
<script>
import AdminEnAttenteTermine from "@/components/insight/PageDashboard/AdminEnAttenteTermine";
import AdminRoueCheckboxs from "@/components/insight/PageDashboard/AdminRoueCheckboxs";
import { mapGetters } from "vuex";

export default {
  components: {
    AdminEnAttenteTermine,
    AdminRoueCheckboxs
  },
  data() {
    return {
      affichageRoueCheckboxs: true,
      affichageIds: false,
      insight_window_size: window.innerWidth
    };
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
  computed: {
    ...mapGetters([
      "insight_resultats",
      "array_participants_termine",
      "resultatsIds"
    ])
  }
};
</script>
